import React, { useState } from "react";

import img5 from "../assets/img/02-2025/5_0.png";
import img6 from "../assets/img/02-2025/6_0.png";
import img7 from "../assets/img/02-2025/7_0.png";
import img8 from "../assets/img/02-2025/8_0.png";

import sornUp from "../assets/img/icon/sorn-up.svg";

export default function Select4(border) {
  const [dataS, setDataS] = useState(null);
  return (
    <>
      <div className="mb-4">
        <div className="row justify-content-center text-start">
          <div className="col-6 col-md-3 col-lg-3">
            <button className="btn text-center" onClick={(e) => setDataS(1)}>
              <img src={img5} className="w-75 px-4" />
              <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                Objectives
              </h4>
            </button>
          </div>
          <div className="col-6 col-md-3 col-lg-3">
            <button className="btn text-center" onClick={(e) => setDataS(2)}>
              <img src={img6} className="w-75 px-4" />
              <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                Participants
              </h4>
            </button>
          </div>
          <div className="col-6 col-md-3 col-lg-3">
            <a
              href="https://drive.google.com/file/d/1r8LT-wxiS9sKLKJwhGcEiWNPmkz6dglj/view?usp=drive_link"
              target={"_blank"}
              className="btn text-center"
            >
              <img src={img7} className="w-75 px-4" />
              <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                Programme
              </h4>
            </a>
          </div>
          <div className="col-6 col-md-3 col-lg-3">
            <a
              href="https://drive.google.com/file/d/1p8cEamJRMqU8BjZ6-gY6-ru0W4_IOYbq/view?usp=drive_link"
              target={"_blank"}
              className="btn text-center"
            >
              <img src={img8} className="w-75 px-4" />
              <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                Document
              </h4>
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="d-none d-md-block">
          <div className="row text-start" style={{ marginBottom: "-20px" }}>
            <div className="col-12 col-md-3 col-lg-3 text-center">
              {dataS === 1 && (
                <img
                  src={sornUp}
                  className=""
                  style={{
                    width: "50px",
                    filter:
                      "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)",
                  }}
                />
              )}
            </div>
            <div className="col-12 col-md-3 col-lg-3 text-center">
              {dataS === 2 && (
                <img
                  src={sornUp}
                  className=""
                  style={{
                    width: "50px",
                    filter:
                      "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)",
                  }}
                />
              )}
            </div>
          </div>
        </div>
        {dataS === 1 ? (
          <div
            className="p-4"
            style={{ background: "#FFDE59", borderRadius: "15px" }}
          >
            <ol>
              <li>
                Enhance understanding and explore the Sufficiency Economy
                Philosophy and its related principles, carbon neutrality,
                net-zero goals, and climate actions through context-specific
                student projects, school policies, and lesson plans aimed at
                promoting sustainability.
              </li>
              <li>
                Facilitate the sharing of experiences on implementing a
                whole-school approach to building a sustainability culture,
                including ideas for school partnerships, student leadership, and
                creating an inclusive environment that supports context-based
                sustainability initiatives.
              </li>
              <li>
                Showcase best practices from SEAMEO Member Countries in
                school-led sustainability and climate action to strengthen
                knowledge sharing and regional networking.
              </li>
            </ol>
          </div>
        ) : dataS === 2 ? (
          <div
            className="p-4"
            style={{ background: "#FFDE59", borderRadius: "15px" }}
          >
            <div>
              A total of 52 high school students from 10 SEAMEO Member Countries
              and the People’s Republic of China (2 females and 2 males, aged
              15-17 or grade 9-11) were from 13 schools nominated by the
              Ministries of Education of SEAMEO Member Countries.
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
